import { Screen } from '@components/Layout'
import { FormManager } from '@components/forms'
import { FormikValues } from 'formik'
import Head from 'next/head'
import { useState } from 'react'
import { useIntl } from 'react-intl'

import { ScreenTemplate } from './ScreenTemplate'
import { SignUpScreenId } from './utils/screenDefinitions/signUpScreens'
import { getNextScreenId, getScreenFromId } from './utils/screenUtils'

export const SignUp = () => {
  const { formatMessage } = useIntl()

  // todo: calculate which screen to start on and initial values based on LS
  const [currentScreenId, setCurrentScreenId] = useState<SignUpScreenId>(
    SignUpScreenId.WHEN_TO_START
  )

  const handleNext = (values: FormikValues) => {
    // todo: update LS with values

    // calculate next screen id from answers provided so far
    const nextScreenId = getNextScreenId(values)

    // if nextScreenId exists, set current screen to nextScreenId
    if (nextScreenId) {
      setCurrentScreenId(nextScreenId)
    } else {
      // if last screen
      sendAnswers()
    }
  }

  const sendAnswers = () => {
    // submit to BE
    // router.push to profile
    // eslint-disable-next-line
    console.log('Form submited. The end')
  }

  return (
    <Screen maxWidth={['container.xl', 'container.sm']} flex={1}>
      <Head>
        <title>
          {formatMessage({
            defaultMessage: 'Sign up - Gaia',
          })}
        </title>
      </Head>
      <FormManager
        initialValues={{}} // take this from LS
        onSubmit={handleNext}
        flex={1}
        display="flex"
      >
        {({ isSubmitting, setSubmitting, values }) => {
          return (
            <ScreenTemplate
              screen={getScreenFromId(currentScreenId)}
              currentScreenId={currentScreenId}
              setCurrentScreenId={setCurrentScreenId}
              isSubmitting={isSubmitting}
              setSubmitting={setSubmitting}
              values={values}
            />
          )
        }}
      </FormManager>
    </Screen>
  )
}
